/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const batchItemAncestorsRequestSchema = z.object({
  ids: z.array(z.int()).min(0).max(100),
});
